import { MET_SAL_SUMMARY_ITEM } from './met-sal-summary.js'
import { MET_SAL_EVOLUTION_ITEM } from './met-sal-evolution.js'
import { MET_SAL_FILTERS_ITEM } from './met-sal-filters.js'
import { MET_SAL_CLIENTS_ITEM } from './met-sal-clients.js'
import { MET_SAL_AI_REPORTS_ITEM } from './met-sal-ai-reports.js'

/** @type {import('../help-index.js').HelpScreen} */
export const MET_SAL_HELP = {
  screenId: 'met-sal',
  label: 'Ventas',
  navPath: 'Métricas → Ventas',
  keywords: [
    'reporte ventas',
    'evolución',
    'ticket promedio',
    'clientes',
    'informes ia',
    'informe ia',
    'inteligencia artificial',
    'métricas ventas',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Indicadores de facturación: resumen, evolución, filtros, clientes e informes automáticos con IA.',
  sidebarItems: [
    MET_SAL_SUMMARY_ITEM,
    MET_SAL_EVOLUTION_ITEM,
    MET_SAL_FILTERS_ITEM,
    MET_SAL_CLIENTS_ITEM,
    MET_SAL_AI_REPORTS_ITEM,
  ],
}
